module.exports = __webpack_public_path__ + "img/chevron-right-2.a010d05e.svg";